import { createAction } from 'typesafe-actions';

import { SetCurrentCountryPayload } from './currentCountry.types';

export const setCurrentCountry = createAction('SET_CURRENT_COUNTRY')<SetCurrentCountryPayload>();